import { useState } from 'react';
import { states } from '../../../mocks/states';

export default function ServiceAreaMap() {
  const [selectedRegion, setSelectedRegion] = useState('all');

  const regions = [
    { id: 'all', name: 'Todo Brasil', icon: 'ri-map-2-fill' },
    { id: 'norte', name: 'Norte', icon: 'ri-map-pin-fill' },
    { id: 'nordeste', name: 'Nordeste', icon: 'ri-map-pin-fill' },
    { id: 'centro-oeste', name: 'Centro-Oeste', icon: 'ri-map-pin-fill' },
    { id: 'sudeste', name: 'Sudeste', icon: 'ri-map-pin-fill' },
    { id: 'sul', name: 'Sul', icon: 'ri-map-pin-fill' }
  ];

  return (
    <section id="area" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-4">Cobertura Nacional</h2>
          <p className="text-xl text-gray-600">Atendemos em todos os estados do Brasil</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column - States List */}
          <div>
            {/* Region Filter */}
            <div className="flex flex-wrap gap-3 mb-8">
              {regions.map((region) => (
                <button
                  key={region.id}
                  onClick={() => setSelectedRegion(region.id)}
                  className={`flex items-center gap-2 px-5 py-3 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                    selectedRegion === region.id
                      ? 'bg-yellow-500 text-black shadow-lg'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  <i className={`${region.icon} text-lg`}></i>
                  <span>{region.name}</span>
                </button>
              ))}
            </div>

            {/* States Grid */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {states.map((state, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl hover:bg-yellow-50 hover:border-yellow-500 border-2 border-transparent transition-all group"
                >
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-2xl text-green-500 group-hover:scale-110 transition-transform"></i>
                  </div>
                  <span className="font-medium text-gray-800">{state}</span>
                </div>
              ))}
            </div>

            <div className="bg-yellow-50 border-2 border-yellow-500 rounded-2xl p-6">
              <h3 className="font-bold text-black text-xl mb-3">Cobertura Completa</h3>
              <p className="text-gray-700 leading-relaxed">
                Nossa rede de guinchos está estrategicamente posicionada em todas as capitais 
                e principais cidades do Brasil, garantindo atendimento rápido onde você estiver.
              </p>
            </div>
          </div>

          {/* Right Column - Map */}
          <div className="relative">
            <div className="bg-gradient-to-br from-gray-100 to-gray-50 rounded-3xl p-8 shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/830af7cd6c0404a92edb79d917c014ea.jpg"
                alt="Mapa de Cobertura Brasil"
                className="w-full h-auto rounded-2xl object-cover"
              />

              {/* Pulsing Pins Overlay */}
              <div className="absolute top-1/4 left-1/3 animate-pulse">
                <div className="w-4 h-4 bg-yellow-500 rounded-full shadow-lg"></div>
              </div>
              <div className="absolute top-1/3 right-1/4 animate-pulse" style={{ animationDelay: '0.5s' }}>
                <div className="w-4 h-4 bg-yellow-500 rounded-full shadow-lg"></div>
              </div>
              <div className="absolute bottom-1/3 left-1/2 animate-pulse" style={{ animationDelay: '1s' }}>
                <div className="w-4 h-4 bg-yellow-500 rounded-full shadow-lg"></div>
              </div>
            </div>

            {/* Coverage Stats */}
            <div className="grid grid-cols-2 gap-4 mt-6">
              <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
                <i className="ri-map-pin-2-fill text-4xl text-yellow-500 mb-2"></i>
                <p className="text-3xl font-bold text-black">27</p>
                <p className="text-gray-600 font-medium">Estados</p>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
                <i className="ri-building-fill text-4xl text-yellow-500 mb-2"></i>
                <p className="text-3xl font-bold text-black">500+</p>
                <p className="text-gray-600 font-medium">Cidades</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}